export const getRatingClasses = (rating) => {
  switch (rating?.description) {
    case "Excellent":
      return "bg-rating-excellent text-white";
    case "Good":
      return "bg-rating-good text-stone-900";
    case "Fair":
      return "bg-rating-fair text-stone-900";
    case "Poor":
      return "bg-rating-poor text-stone-900";
    case "Terrible":
      return "bg-rating-terrible text-white";
    default:
      return "bg-stone-300 text-stone-900";
  }
};
